
import { Component, Vue, Prop } from "vue-property-decorator";
import { TreeNode } from "@/types/tree";
import {
  calculateElementPositionOnCanvas,
  listenForPositionChangesAndGetNewPosition,
  ElementPositionOnCanvas,
  getWrapperStyle,
  getOutlineStyle
} from "@/futurelayer/canvas/canvas-controls/element-positioning";
import { getLinkPropertyPathsForElement } from "@/futurelayer/links/links";
import { singularityStore } from "@/store/store";

@Component
export default class FutureLayerLinkWrapperOutlineAndControls extends Vue {
  @Prop()
  element!: TreeNode;

  elementPositionOnCanvas: ElementPositionOnCanvas = false;
  cleanupListeners: () => void = () => {};

  mounted() {
    this.elementPositionOnCanvas = calculateElementPositionOnCanvas(
      this.element
    );

    this.cleanupListeners = listenForPositionChangesAndGetNewPosition(
      this.element,
      (newPosition: ElementPositionOnCanvas) => {
        this.elementPositionOnCanvas = newPosition;
      }
    );
  }

  beforeDestroy() {
    this.cleanupListeners();
  }

  get cssStyleForWrapper(): Record<string, string> {
    return getWrapperStyle(this.elementPositionOnCanvas);
  }

  get cssStyleForOutline(): Record<string, string> {
    return getOutlineStyle(this.elementPositionOnCanvas);
  }

  get cssStyleForControls(): Record<string, string> {
    if (!this.elementPositionOnCanvas) {
      return { display: "none" };
    }

    return {
      left: "0",
      top: `0px`,
      transform: "translateY(-100%)"
    };
  }

  handleEditLink() {
    const linkPropertyPaths = getLinkPropertyPathsForElement(
      this.element.data.type
    );
    if (!linkPropertyPaths) return;

    singularityStore.setLinkEditorPanelState({
      elementId: this.element.id,
      linkPropertyPaths: linkPropertyPaths
    });
    singularityStore.setSingularityLeftPanel("link_editor");
  }
}
